import axios from 'axios';

/**
 * Request-сервис для выполнения запросов к API
 */
class ApiRequest {
    private endpoint: string = '';
    private readonly defaultOptions: object = { withCredentials: true };

    public setBaseUrl(url: string) {
        this.endpoint = url;
    }

    public async get<T = any>(url: string, options = {} as object): Promise<T> {
        const response = await axios.get(`${this.endpoint}${url}`, { ...this.defaultOptions, ...options });

        return response.data;
    }
}

// Экспортируем как сингелтон
export default new ApiRequest();
